import { polygonZkEvmTokens } from '@pancakeswap/tokens'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { Strategy, VaultConfig } from '../../types'
import { MANAGER } from '../managers'

export const vaults: VaultConfig[] = [
  {
    id: 5,
    idByManager: 5,
    name: 'BRIL',
    manager: MANAGER.BRIL,
    bCakeWrapperAddress: '0x200DcA6aaeE1BCBf5aA839c8D8E93a69688ffcF0',
    address: '0x200DcA6aaeE1BCBf5aA839c8D8E93a69688ffcF0',
    adapterAddress: '0x195C8d4439831a8B302F3Ceca15785216E94a62B',
    vaultAddress: '0x03B832F38878DC9478Ed8127Cb46C7c094a94941',
    currencyA: polygonZkEvmTokens.matic,
    currencyB: polygonZkEvmTokens.grai,
    earningToken: polygonZkEvmTokens.cake,
    feeTier: FeeAmount.MEDIUM,
    strategy: Strategy.YIELD_IQ,
    isSingleDepositToken: true,
    allowDepositToken0: true,
    allowDepositToken1: false,
    managerInfoUrl: 'https://www.bril.finance/',
    strategyInfoUrl: 'https://docs.bril.finance/yield-iq/overview',
    learnMoreAboutUrl: 'https://docs.bril.finance/bril-finance/introduction',
  },
  {
    id: 4,
    idByManager: 4,
    name: 'BRIL',
    manager: MANAGER.BRIL,
    bCakeWrapperAddress: '0x055a61Bf6fBD499aD718094eF4883F58C32628dd',
    address: '0x055a61Bf6fBD499aD718094eF4883F58C32628dd',
    adapterAddress: '0x4Af6c2937afA5e168584a3498bA8D05C5794b9Dc',
    vaultAddress: '0x5Eb74D624b60B3A9336a37509AF62f6906975264',
    currencyA: polygonZkEvmTokens.usdce,
    currencyB: polygonZkEvmTokens.grai,
    earningToken: polygonZkEvmTokens.cake,
    feeTier: FeeAmount.LOW,
    strategy: Strategy.YIELD_IQ,
    isSingleDepositToken: true,
    allowDepositToken0: true,
    allowDepositToken1: false,
    managerInfoUrl: 'https://www.bril.finance/',
    strategyInfoUrl: 'https://docs.bril.finance/yield-iq/overview',
    learnMoreAboutUrl: 'https://docs.bril.finance/bril-finance/introduction',
    priceFromV3FarmPid: 20,
  },
  {
    id: 3,
    idByManager: 3,
    name: 'BRIL',
    manager: MANAGER.BRIL,
    bCakeWrapperAddress: '0x6ef151413502046479e6Cac5378AD737D09fe61D',
    address: '0x6ef151413502046479e6Cac5378AD737D09fe61D',
    adapterAddress: '0x4403025D25DC1768B87224FDDfe96394Caa35c58',
    vaultAddress: '0x36ED8160b40eA5A5c267Ca1362e329805B7eb9E4',
    currencyA: polygonZkEvmTokens.weth,
    currencyB: polygonZkEvmTokens.rsETH,
    earningToken: polygonZkEvmTokens.matic,
    feeTier: FeeAmount.LOW,
    strategy: Strategy.YIELD_IQ,
    isSingleDepositToken: true,
    allowDepositToken0: true,
    allowDepositToken1: false,
    managerInfoUrl: 'https://www.bril.finance/',
    strategyInfoUrl: 'https://docs.bril.finance/yield-iq/overview',
    learnMoreAboutUrl: 'https://docs.bril.finance/bril-finance/introduction',
    priceFromV3FarmPid: 10,
  },
  {
    id: 2,
    idByManager: 2,
    name: 'BRIL',
    manager: MANAGER.BRIL,
    bCakeWrapperAddress: '0x2C3F0aD2fa20aDedeD322Ec2d2cb1CA1656b176d',
    address: '0x2C3F0aD2fa20aDedeD322Ec2d2cb1CA1656b176d',
    adapterAddress: '0xd4358AE4B833c8fd39E5497A3EdC7fF430a57B8c',
    vaultAddress: '0x02F3893D0A1725155357dA6125d0f3Ca67d86FbB',
    currencyA: polygonZkEvmTokens.weth,
    currencyB: polygonZkEvmTokens.reth,
    earningToken: polygonZkEvmTokens.matic,
    feeTier: FeeAmount.LOW,
    strategy: Strategy.YIELD_IQ,
    isSingleDepositToken: true,
    allowDepositToken0: true,
    allowDepositToken1: false,
    managerInfoUrl: 'https://www.bril.finance/',
    strategyInfoUrl: 'https://docs.bril.finance/yield-iq/overview',
    learnMoreAboutUrl: 'https://docs.bril.finance/bril-finance/introduction',
    priceFromV3FarmPid: 13,
  },
  {
    id: 1,
    idByManager: 1,
    name: 'BRIL',
    manager: MANAGER.BRIL,
    bCakeWrapperAddress: '0x308Cb883074b270700096a5931BfFF81701b44f2',
    address: '0x308Cb883074b270700096a5931BfFF81701b44f2',
    adapterAddress: '0xc44940c05aA4a24a637EaC3A6be1bc763a24Ef5d',
    vaultAddress: '0x5c3603Cef7BD6f42177C119cC4e3a6C1f38DDffe',
    currencyA: polygonZkEvmTokens.weth,
    currencyB: polygonZkEvmTokens.wstETH,
    earningToken: polygonZkEvmTokens.matic,
    feeTier: FeeAmount.LOW,
    strategy: Strategy.YIELD_IQ,
    isSingleDepositToken: true,
    allowDepositToken0: true,
    allowDepositToken1: false,
    managerInfoUrl: 'https://www.bril.finance/',
    strategyInfoUrl: 'https://docs.bril.finance/yield-iq/overview',
    learnMoreAboutUrl: 'https://docs.bril.finance/bril-finance/introduction',
    priceFromV3FarmPid: 12,
  },
]
